import * as React from 'react'
import { css } from '@emotion/react'
import { StaticImage } from 'gatsby-plugin-image'

const Visual = () => {
  return (
    <div css={baseStyle}>
      <div css={layerStyle}>
        <h1 css={titleStyle}>POP-UP 3D</h1>
        <p css={textStyle}>オンラインで見て楽しんで気に入ったら買う！</p>
      </div>
      <div css={showPcStyle}>
        <div css={images01Style}>
          <StaticImage src="../assets/images/visual01.png" alt="" />
        </div>
        <div css={images02Style}>
          <StaticImage src="../assets/images/visual02.png" alt="" />
        </div>
      </div>
      <div css={showSpStyle}>
        <div css={images01Style}>
          <StaticImage src="../assets/images/visual_sp.png" alt="" />
        </div>
      </div>
    </div>
  )
}

const baseStyle = css`
  position: relative;
  display: flex;
  width: 100%;
  height: 350px;
  overflow: hidden;
  @media (max-width: 768px) {
    width: 100%;
    height: 245px;
  }
`
const layerStyle = css`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 50;
`
const titleStyle = css`
  font-size: 6.8rem;
  font-weight: 900;
  line-height: 1;
  color: #3a3042;
  @media (max-width: 768px) {
    font-size: 4.8rem;
  }
`
const textStyle = css`
  padding-top: 8px;
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1;
  color: #3a3042;
  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`
const images01Style = css`
  position: absolute;
  width: 1920px;
  top: 0;
  left: 50%;
  transform: translatex(-50%);
  z-index: 1;
  @media (max-width: 414px) {
    width: 100%;
  }
`
const images02Style = css`
  position: absolute;
  top: 0;
  right: 0;
  width: 700px;
  z-index: 10;
  @media (max-width: 768px) {
    width: 70%;
    left: 40%;
    right: initial;
  }
`
const showPcStyle = css`
  @media (max-width: 414px) {
    display: none;
  }
`
const showSpStyle = css`
  display: none;
  @media (max-width: 414px) {
    display: flex;
  }
`

export default Visual
